import { DurationString } from '@cast/shared-types';
import { durationToUnit } from '@cast/utils';

import { NumberClusterConfig, TimeClusterConfig } from './types';

export const numberClusterConfig: NumberClusterConfig = {
  100: 10,
  500: 50,
  1000: 100,
  5000: 500,
  10000: 1000,
  100000: 10000,
};

export const numberClusterConfigFallback = 10000;

export const timeClusterConfig: TimeClusterConfig = {
  // up to 5 mins - every 1 min
  '5m': 60,
  // up to 1 hour - every 10 mins
  '1h': 600,
  // up to 6 hours - every 30mins
  '6h': 1800,
  // up to 24 hours - every hour
  '1d': 3600,
  // up to 1 month - every day
  '31d': 86400,
  // up to 3 months - every 2 weeks
  '6months': 1209600,
  // up to 1 year - every 30 days
  '1y': 2592000,
};

export const timeClusterConfigFallback = 86400;

export const sortedTimeClusterEntries = Object.entries(timeClusterConfig)
  .map(([rangeStr, value]) => ({
    range: durationToUnit(rangeStr as DurationString, 'ms'),
    value,
  }))
  .sort((a, b) => a.range - b.range);

export const sortedNumberClusterEntries = Object.entries(numberClusterConfig)
  .map(([rangeStr, value]) => ({
    range: Number(rangeStr),
    value,
  }))
  .sort((a, b) => a.range - b.range);
